// 本地数据持久化
import { isJsonString } from './tool'

function setLS(item: string, value: string, expire?: number) {
  // value若为对象, 请事先用 JSON.stringify转化
  // 设置超时时间
  if (expire) {
    value += '?expire=' + new Date().getTime() + expire
  }
  window.localStorage.setItem(item, value)
}

function getLS(item: string) {
  let data = window.localStorage.getItem(item) || ''
  let expireIndex = data.indexOf('?expire=')
  // 表示设置了过期时间
  if (expireIndex > 0) {
    let expireData = data.substring(expireIndex)
    let value = data.substring(0, expireIndex)
    let expireTime = Number(expireData.substring(8))
    // 判断是否过期
    if (expireTime < (new Date().getTime())) {
      removeLS(item)
      return ''
    } else {
      return isJsonString(value) ? JSON.parse(value) : value
    }
  } else {
    return isJsonString(data) ? JSON.parse(data) : data
  }
}

function removeLS(item: string) {
  window.localStorage.removeItem(item)
}

// 按需
export {
  setLS,
  getLS,
  removeLS
}
